import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { stockInitialOrderReviewParam } from "features/stock-ordering/core/stock-ordering.params";
import {
  stockInitialOrderReviewRepository,
  stockInitialOrderReviewResponse,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum StockInitialOrderReviewState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: StockInitialOrderReviewState;
  message: string;
}

const initialState: InitialState = {
  status: StockInitialOrderReviewState.initial,
  message: "",
};

export const stockInitialOrderReview = createAsyncThunk(
  "stockInitialOrderReview",
  async (param: stockInitialOrderReviewParam, { rejectWithValue }) => {
    try {
      const response: stockInitialOrderReviewResponse =
        await stockInitialOrderReviewRepository(param);

      return response.data;
    } catch (error) {
      console.log(error);

      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const stockInitialOrderReviewSlice = createSlice({
  name: "stockInitialOrderReview",
  initialState,
  reducers: {
    resetStockInitialOrderReview: (state) => {
      state.status = StockInitialOrderReviewState.inProgress;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(stockInitialOrderReview.pending, (state) => {
        state.status = StockInitialOrderReviewState.inProgress;
      })
      .addCase(stockInitialOrderReview.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = StockInitialOrderReviewState.success;
          state.message = message;
        }
      })
      .addCase(stockInitialOrderReview.rejected, (state, action) => {
        state.status = StockInitialOrderReviewState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectStockInitialOrderReview = (state: RootState) =>
  state.stockInitialOrderReview;

export const { resetStockInitialOrderReview } =
  stockInitialOrderReviewSlice.actions;
export default stockInitialOrderReviewSlice.reducer;
